var textWrapper = document.querySelector('.custom_collapsible_text');
let list = document.querySelector('.custom_outer_layout');



function openMenuAndShowFirst() {
    let icon = textWrapper.querySelector('.icon-chevron-down');
    if (icon || list) {
        icon.classList.add('icon-chevron-up');
        list.classList.add('show');
        let firstHoverText = document.querySelector('.custom_lists_wrapper .hover_text');
        if (firstHoverText) {
            showHideDescriptions(firstHoverText);
        }
    }
}

textWrapper.addEventListener('click', function() {
    // If already open, just show first hovered description
    if (list.classList.contains('show')) {
        let firstHoverText = document.querySelector('.custom_lists_wrapper .hover_text');
        if (firstHoverText) {
            showHideDescriptions(firstHoverText);
        }
    } else {
        openMenuAndShowFirst();
    }
});

function detectHover() {
    let hoverTexts = document.querySelectorAll('.custom_lists_wrapper .hover_text');
    if (hoverTexts.length === 0) return;

    hoverTexts.forEach(text => {
        text.addEventListener('mouseover', (event) => {
            showHideDescriptions(event.target);
        })
    });

    stylemarginTop()
}

function showHideDescriptions(hoveredDiv) {
    if (!hoveredDiv) return;
    let collectionName = hoveredDiv.classList.value.replace('hover_text', '').trim();

    let allIDs = [...list.querySelectorAll('.hovered_text > div')].map(({ id }) => id);

    allIDs.forEach(id => {
        if (collectionName !== id) {
            document.getElementById(id).style.display = null;
        } else {
            document.getElementById(id).style.display = "flex";
        }
    });
}

function stylemarginTop() {
    let header = document.getElementById('header');
    if (!header || !list) return;

    let headerHeight = header.offsetHeight;
    list.style.marginTop = headerHeight.toString() + 'px';
}

detectHover()